import axios from 'axios';

const csrfService = axios.create({
    baseURL: process.env.VUE_APP_URL_COOKIE,
    withCredentials: true,
})

export default csrfService